// used for checking component to render in switch case
enum DISABLE_2FA_FLOW {
  FACE_AUTH = 'FACE_AUTH',
  EMAIL_OTP_VERIFICATION = 'EMAIL_OTP_VERIFICATION',
  SDK_SUCCESS = 'SDK_SUCCESS',
  EMAIL_VERIFICATION = 'EMAIL_VERIFICATION',
  RAISE_TICKET = 'RAISE_TICKET',
  RESET_2FA_DONE = 'RESET_2FA_DONE',
  FACE_AUTH_FAILED = 'FACE_AUTH_FAILED',
  FACE_AUTH_REJECTED = 'FACE_AUTH_REJECTED',
}

enum VERIFY_FLOW {
  VERIFY_EMAIL_PASS = 'VERIFY_EMAIL_PASS',
}

enum OTP_VERIFICATION_ERROR_CODES {
  INVALID_OTP = 'invalid_otp',
  BLOCKED = 'verify_email_blocked',
  S3_ERROR = 's3_error',
}

export { VERIFY_FLOW, DISABLE_2FA_FLOW, OTP_VERIFICATION_ERROR_CODES };
